import React from "react";
import { bool } from "prop-types";

import BaseMenu from "./BaseMenu";
import TipsAndUpdatesRoundedIcon from "shared/chrome/menus/icons/TipsAndUpdatesRoundedIcon";
import MoreTimeRoundedIcon from "shared/chrome/menus/icons/MoreTimeRoundedIcon";

const UpdatesMenu = ({ useRouterNavigation = true }) => {
  return (
    <BaseMenu
      menuTitle="Updates"
      MenuIcon={TipsAndUpdatesRoundedIcon}
      useRouterNavigation={useRouterNavigation}
      items={[
        {
          text: "Recent updates",
          icon: <MoreTimeRoundedIcon />,
          href: "/updates",
          googleAnalyticsLabel: "Updates: Updates",
        },
        {
          text: "Coming soon",
          icon: <TipsAndUpdatesRoundedIcon />,
          href: "/coming-soon",
          googleAnalyticsLabel: "Updates: Coming Soon",
        },
      ]}
    />
  );
};

UpdatesMenu.propTypes = {
  useRouterNavigation: bool,
};

export default UpdatesMenu;
